import { useMutation } from '@tanstack/react-query'
import {
  setHockeyCanadaIntegration,
  type SetHockeyCanadaIntegrationInput,
} from '@sportninja/common/services/account/hockeyCanadaIntegration'

/**
 * Mutation for enabling/disabling the Hockey Canada integration.
 *
 * Deliberately does NOT refetch the account on success. The request already
 * confirms the new state, and the caller applies it locally — matching the USA
 * Hockey card. Refetching also triggered a second GET /account/:id, because
 * MainNav re-fetches whenever the account slice changes.
 */
export const useSetHockeyCanadaIntegration = () => {
  return useMutation<void, Error, SetHockeyCanadaIntegrationInput>({
    mutationFn: setHockeyCanadaIntegration,
    // Override the global mutations.retry=1 default — a failed toggle should
    // surface immediately rather than firing the billing-relevant call twice.
    retry: 0,
  })
}
